export type GastronomyStockMode = 'A' | 'B' | 'C';

export const GASTRONOMY_STOCK_MODE_OPTIONS: ReadonlyArray<{
  mode: GastronomyStockMode;
  title: string;
  description: string;
}> = [
  {
    mode: 'A',
    title: 'Vendo lo que está en la carta',
    description:
      'Cada plato o bebida es un producto con su stock. Sin composición ni producción. Dejamos la venta bloqueada si no hay stock.',
  },
  {
    mode: 'B',
    title: 'Carta con combos e insumos',
    description:
      'Los combos descuentan pan, carne y guarnición. Opciones como doble o triple. Bloqueamos la venta sin stock y el vendible asume el peor tamaño.',
  },
  {
    mode: 'C',
    title: 'Combos y producción',
    description:
      'Igual que combos, más recetas para producir en depósito cuando quieras. Misma política de bloqueo y vendible conservador.',
  },
];

export function isGastronomyStockMode(value: string | null | undefined): value is GastronomyStockMode {
  return value === 'A' || value === 'B' || value === 'C';
}
